import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import { Card } from "@/components/ui/card";
import { Check } from "lucide-react";
export default function ServicesPage() {
  return <div>
      <Header />
      
      <main className="min-h-screen bg-gradient-to-b from-slate-50 to-white">
        {/* Hero Section */}
        <section className="py-16 px-4 sm:px-6 lg:px-8 max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
              Therapeutic Bodywork Services
            </h1>
            <p className="text-lg text-slate-600 max-w-2xl mx-auto">
              Personalized wellness plans tailored to your unique needs
            </p>
          </div>

          {/* Pricing Cards */}
          <div className="grid md:grid-cols-2 gap-8 lg:gap-10">
            {/* Initial Evaluation Card */}
            <Card className="border-2 border-slate-200 shadow-lg hover:shadow-xl transition-shadow overflow-hidden">
              <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-8">
                <h2 className="text-3xl font-bold text-slate-900 mb-2">
                  Initial Evaluation
                </h2>
                <p className="text-slate-600 mb-6">
                  Comprehensive intake and customized wellness plan
                </p>

                {/* Pricing Options */}
                <div className="space-y-3 mb-8">
                  <div className="bg-white rounded-lg p-4 border border-slate-200">
                    <p className="text-sm text-slate-600 mb-1">In-Home (Special Offer)</p>
                    <p className="text-3xl font-bold text-blue-600">$125</p>
                  </div>
                  <div className="bg-white rounded-lg p-4 border border-slate-200">
                    <p className="text-sm text-slate-600 mb-1">Clinic (Special Offer)</p>
                    <p className="text-3xl font-bold text-blue-600">$100</p>
                  </div>
                </div>

                {/* Features */}
                <div className="space-y-4">
                  <div className="flex gap-3">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="font-semibold text-slate-900">Travel Included</p>
                      <p className="text-sm text-slate-600">
                        To your home (within 20 min of Downtown Durango)
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-3">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="font-semibold text-slate-900">Comprehensive Session</p>
                      <p className="text-sm text-slate-600">
                        60–75 min combined intake assessment and bodywork session
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-3">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="font-semibold text-slate-900">Wellness Plan</p>
                      <p className="text-sm text-slate-600">
                        Customized plan established during session
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Card>

            {/* Follow-Up Massage Card */}
            <Card className="border-2 border-slate-200 shadow-lg hover:shadow-xl transition-shadow overflow-hidden">
              <div className="bg-gradient-to-r from-emerald-50 to-teal-50 p-8">
                <h2 className="text-3xl font-bold text-slate-900 mb-2">
                  Follow-Up Massage
                </h2>
                <p className="text-slate-600 mb-6">
                  Ongoing therapeutic bodywork session
                </p>

                {/* Pricing Options */}
                <div className="space-y-3 mb-8">
                  <div className="bg-white rounded-lg p-4 border border-slate-200">
                    <p className="text-sm text-slate-600 mb-1">In-Home (Special Offer)</p>
                    <p className="text-3xl font-bold text-emerald-600">$100</p>
                  </div>
                  <div className="bg-white rounded-lg p-4 border border-slate-200">
                    <p className="text-sm text-slate-600 mb-1">Clinic (Special Offer)</p>
                    <p className="text-3xl font-bold text-emerald-600">$90</p>
                  </div>
                </div>

                {/* Features */}
                <div className="space-y-4">
                  <div className="flex gap-3">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="font-semibold text-slate-900">Travel Included</p>
                      <p className="text-sm text-slate-600">
                        To your home (within 20 min of Downtown Durango)
                      </p>
                    </div>
                  </div>
                  <div className="flex gap-3">
                    <Check className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
                    <div>
                      <p className="font-semibold text-slate-900">Bodywork Session</p>
                      <p className="text-sm text-slate-600">
                        45–55 min therapeutic session
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
          </div>

          {/* Notes Section */}
          <div className="mt-12 bg-amber-50 border border-amber-200 rounded-lg p-6 max-w-2xl mx-auto">
            <h3 className="font-semibold text-slate-900 mb-3">Note:</h3>
            <p className="text-slate-700">Smaller breeds may require less time – Larger breeds may require more time.<br />Inquire for distances beyond 20 min from Durango.</p>
          </div>
        </section>
      </main>

      <Footer />
    </div>;
}